export const API_BASE = "/api";
export const TOKEN_ADDRESS = "0x3a14785035CF80aD95a969Bfc750584a3C16A6E6";
export const STAKING_V1_ADDRESS = "0xD087fF477037898cFb24477192F4Be9e5fE3E53d";
export const STAKING_V2_ADDRESS = "0x8ae2742aa50842170bda33ebfac9db76102b5314";
export const DECIMALS = 18;

export const BSC_PARAMS = {
  chainId: "0x38",
  chainName: "BNB Smart Chain",
  nativeCurrency: { name: "BNB", symbol: "BNB", decimals: 18 },
  rpcUrls: ["https://bsc-dataseed.binance.org"],
  blockExplorerUrls: ["https://bscscan.com"],
};